export default function Hero() {
  return (
    <section
      id="hero"
      className="section-scroll relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-gradient-to-br from-gray-950 via-gray-900 to-red-950"
    >
      <div className="absolute inset-0 overflow-hidden opacity-30">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-red-600/20 blur-3xl"></div>
        <div className="absolute top-1/2 -left-32 w-80 h-80 rounded-full bg-amber-500/15 blur-3xl"></div>
        <div className="absolute -bottom-20 right-1/3 w-72 h-72 rounded-full bg-red-500/10 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-12 py-12 md:py-16">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-600/20 border border-red-500/30 mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-red-400 animate-pulse"></span>
              <span className="text-red-300 text-xs md:text-sm font-medium">每日更新 · 高清不缓冲 · 完全免费</span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-3">
              91年国产影片视频
              <span className="block text-red-400 mt-1 text-lg md:text-2xl lg:text-3xl font-semibold">
                免费在线观看高清国产影片
              </span>
            </h1>

            <p className="text-red-300/80 text-sm md:text-base font-medium mb-5">
              海量国产影片，随时随地免费看 — 无需注册，打开即播
            </p>

            <p className="text-gray-300 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              作为专业的91免费在线视频平台，我们每日精选最新91精品视频在线播放资源，覆盖91免费视频网站热门内容与91麻豆免费视频网站精选频道。无论您使用电脑还是手机，都能享受高清不缓冲的91在线观看免费体验，真正实现91免费看视频、91在线免费播放的观影自由。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-red-600/30 flex items-center justify-center">
                  <i className="ri-refresh-line text-red-400 text-sm md:text-base"></i>
                </div>
                <div className="text-left">
                  <p className="text-white font-semibold text-sm md:text-base whitespace-nowrap">每日更新</p>
                  <p className="text-gray-400 text-xs">片源持续上新</p>
                </div>
              </div>
              <div className="w-px h-8 bg-white/10 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-amber-500/30 flex items-center justify-center">
                  <i className="ri-film-line text-amber-400 text-sm md:text-base"></i>
                </div>
                <div className="text-left">
                  <p className="text-white font-semibold text-sm md:text-base whitespace-nowrap">片源丰富</p>
                  <p className="text-gray-400 text-xs">万部影片任选</p>
                </div>
              </div>
              <div className="w-px h-8 bg-white/10 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-green-500/30 flex items-center justify-center">
                  <i className="ri-speed-up-line text-green-400 text-sm md:text-base"></i>
                </div>
                <div className="text-left">
                  <p className="text-white font-semibold text-sm md:text-base whitespace-nowrap">高清流畅</p>
                  <p className="text-gray-400 text-xs">不缓冲不卡顿</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 rounded-xl bg-red-600 hover:bg-red-500 text-white font-semibold text-sm md:text-base whitespace-nowrap cursor-pointer transition-all duration-200 hover:scale-105 text-center"
              >
                <i className="ri-play-circle-line mr-2"></i>立即观看
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 rounded-xl bg-white/10 hover:bg-white/20 text-white font-medium text-sm md:text-base whitespace-nowrap cursor-pointer transition-all duration-200 border border-white/20 text-center"
              >
                了解更多 <i className="ri-arrow-right-line ml-1"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg">
              <div className="absolute -inset-2 bg-gradient-to-r from-red-600/20 via-amber-500/20 to-red-600/20 rounded-2xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden bg-gray-900 border border-white/10 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20cinematic%20scene%20with%20vintage%20film%20projector%20casting%20golden%20light%20beams%20through%20a%20dark%20theater%2C%20rich%20amber%20and%20deep%20red%20velvet%20curtains%20framing%20the%20scene%2C%20floating%20film%20strips%20with%20soft%20glow%2C%20dramatic%20theatrical%20lighting%20with%20lens%20flares%2C%20elegant%20cinematography%20aesthetic%2C%20high%20contrast%20chiaroscuro%2C%20digital%20art%20with%20film%20grain%20texture%2C%20nostalgic%20movie%20palace%20atmosphere&width=800&height=600&seq=hero-cinema-2026&orientation=landscape"
                  alt="91年国产影片视频 - 影院级观影体验"
                  className="w-full h-auto object-cover"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.minHeight = '300px';
                      target.parentElement.classList.add('flex', 'items-center', 'justify-center');
                      target.parentElement.innerHTML = '<div class="text-gray-500 text-sm">精彩影片，即刻呈现</div>';
                    }
                  }}
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                  <p className="text-white/80 text-xs flex items-center gap-2">
                    <i className="ri-movie-2-line text-red-400"></i>
                    海量91免费在线视频 · 每日更新
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}